import { useState } from "react";
import { notificationApi } from "api/notification.api";

export interface NotificationItem {
  id: number;
  title: string;
  shortContent: string;
  content: string;
  url: string;
  refId: number;
  refType: string;
  isImportant: boolean;
  isRead?: boolean;
  createdAt: number;
}

export const useNotification = () => {
  const [data, setData] = useState<NotificationItem[]>([]);
  const [total, setTotal] = useState(0);
  const [totalUnread, setTotalUnread] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchData = async (page = 1, limit = 20) => {
    setLoading(true);
    try {
      const { data } = await notificationApi.findAll({ page, limit });
      setData(data?.notifications || []);
      setTotal(data?.total || 0);
    } finally {
      setLoading(false);
    }
  };

  const fetchTotalUnread = async () => {
    try {
      const { data } = await notificationApi.totalUnread();
      setTotalUnread(data?.total || 0);
    } catch {
      // im lặng: badge chỉ ẩn khi API lỗi
    }
  };

  return {
    notifications: data,
    totalNotification: total,
    totalUnread,
    fetchNotification: fetchData,
    fetchTotalUnread,
    loadingNotification: loading,
  };
};
